import React, { Component } from 'react';

class SlideshowsModal extends Component {

    render() {
        const { onCancel, onAdd } = this.props;

        return (
            <div className="modal-body">
                <form onSubmit={(e) => e.preventDefault()}>
                    <h3>Add Slideshow</h3>
                    <div className="form-group browse-file">
                        <label htmlFor="custom-file">Image:
                                <span>(Recommend 2:1 e.g. 1200x600px)</span>
                        </label>
                        <label className="custom-file">
                            <input type="file" id="file2" className="custom-file-input" />
                            <span className="custom-file-control"></span>
                        </label>
                    </div>
                    <div className="modal-botton">
                        <button 
                            className="btn button gray-btn" 
                            type="cancel" 
                            onClick={onCancel}
                        >Cancel</button>
                        <button 
                            className="btn button green-btn" 
                            type="submit"
                            onClick={onAdd}
                        >Add Slideshow</button>
                    </div>
                </form>
            </div>
        )
    }
}

export default SlideshowsModal;


// WEBPACK FOOTER //
// ./src/views/slideshow/SlideshowsModal.js